import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing project-card" }
const _hoisted_3 = { class: "card-body p-20 p-md-25 p-lg-30" }
const _hoisted_4 = { class: "mb-12 mb-md-15 mb-lg-20 d-flex justify-content-between align-items-center" }
const _hoisted_5 = { class: "title d-flex align-items-center" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "ms-15" }
const _hoisted_8 = { class: "mb-1 fs-14 fs-md-16 fs-lg-18 fw-bold mt-8 mt-md-0" }
const _hoisted_9 = {
  key: 0,
  class: "text-secondary fw-light"
}
const _hoisted_10 = { class: "dropdown" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary btn-sm me-15",
  type: "button"
}, " View Research ", -1)
const _hoisted_12 = {
  key: 0,
  class: "dropdown-toggle card-dot-btn lh-1 position-relative top-4 bg-transparent border-0 shadow-none p-0 transition",
  type: "button",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-dots" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "dropdown-menu" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-view lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item d-flex align-items-center",
  href: "javascript:void(0);"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-heart lh-1 me-8 position-relative top-1" }),
  /*#__PURE__*/_createTextVNode(" Favorite")
], -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item d-flex align-items-center",
  href: "javascript:void(0);"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-plus lh-1 me-8 position-relative top-1" }),
  /*#__PURE__*/_createTextVNode(" Add to list")
], -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { key: 2 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("a", {
  class: "dropdown-item d-flex align-items-center",
  href: "javascript:void(0);"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-close lh-1 me-8 position-relative top-1" }),
  /*#__PURE__*/_createTextVNode(" Pass")
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 0,
  class: "mb-12 mb-md-15 mb-lg-25 text-muted lh-base fs-md-13 fs-lg-14"
}
const _hoisted_27 = {
  key: 1,
  class: "mb-12 mb-md-15 mb-lg-25 text-muted lh-base fs-md-13 fs-lg-14"
}
const _hoisted_28 = { class: "text-primary" }
const _hoisted_29 = {
  key: 2,
  class: "mb-12 mb-md-15 mb-lg-25 text-muted lh-base fs-md-13 fs-lg-14"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_CompanyAlignment = _resolveComponent("CompanyAlignment")!
  const _component_CompanyStatus = _resolveComponent("CompanyStatus")!
  const _component_CompanyDescriptors = _resolveComponent("CompanyDescriptors")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.companies, (company) => {
      return (_openBlock(), _createElementBlock("div", {
        key: company.id,
        class: "col-md-12 col-xxl-6 col-xxxl-6"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: '/company-report/'+ company.id
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      src: company.logo ? company.logo : require('@/assets/images/social/social8.jpg'),
                      class: "rounded-1 border p-2 img-thumbnail",
                      width: "60",
                      alt: "project"
                    }, null, 8, _hoisted_6)
                  ]),
                  _: 2
                }, 1032, ["to"]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("h5", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: '/company-report/'+ company.id,
                      class: "text-decoration-none text-black"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(company.name), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"]),
                    (company.stage)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, ": " + _toDisplayString(company.stage), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_CompanyAlignment, { company: company }, null, 8, ["company"]),
                  _createVNode(_component_CompanyStatus, { company: company }, null, 8, ["company"])
                ])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_router_link, {
                  to: '/company-report/'+ company.id
                }, {
                  default: _withCtx(() => [
                    _hoisted_11
                  ]),
                  _: 2
                }, 1032, ["to"]),
                (_ctx.canAccessFeature('favorites') || _ctx.canAccessFeature('customLists') ||_ctx.canAccessFeature('companyActions'))
                  ? (_openBlock(), _createElementBlock("button", _hoisted_12, _hoisted_14))
                  : _createCommentVNode("", true),
                _createElementVNode("ul", _hoisted_15, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: '/company-report/'+ company.id,
                      class: "dropdown-item d-flex align-items-center"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_16,
                        _createTextVNode(" View Report ")
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  (_ctx.canAccessFeature('favorites'))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_17, _hoisted_19))
                    : _createCommentVNode("", true),
                  (_ctx.canAccessFeature('customLists'))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_20, _hoisted_22))
                    : _createCommentVNode("", true),
                  (_ctx.canAccessFeature('companyActions'))
                    ? (_openBlock(), _createElementBlock("li", _hoisted_23, _hoisted_25))
                    : _createCommentVNode("", true)
                ])
              ])
            ]),
            (company.description)
              ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(company.description), 1))
              : _createCommentVNode("", true),
            (company.raised)
              ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                  _createTextVNode(" Raised to Date (Per Crunchbase) "),
                  _createElementVNode("span", _hoisted_28, [
                    _createElementVNode("strong", null, _toDisplayString(company.raised), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (company.founding_year || company.location_country_HQ)
              ? (_openBlock(), _createElementBlock("p", _hoisted_29, [
                  (company.founding_year)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode("Founded in " + _toDisplayString(company.founding_year) + ".", 1)
                      ], 64))
                    : _createCommentVNode("", true),
                  (company.location_country_HQ)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Located in " + _toDisplayString(company.location_country_HQ) + ".", 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_CompanyDescriptors, { company: company }, null, 8, ["company"])
          ])
        ])
      ]))
    }), 128))
  ]))
}